import { createFileRoute } from '@tanstack/react-router';
import { createGroupBroadcastNewRoute } from '@/lib/route-factories/group-broadcast-route';

export const Route = createFileRoute(
  '/_authed/circles/$id/admin/broadcasts/new/',
)(
  createGroupBroadcastNewRoute({
    kind: 'circle',
    fromId: '/_authed/circles/$id/admin/broadcasts/new/',
  }),
);
